import { loginRequest } from "api/auth";
import ContextMenuList from "components/ContextMenu/ContextMenuList";
import Button from "components/shared/button";
import { usePopover } from "providers/PopoverProvider";
import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { getAppUrl } from "utils/defines";
import {
  useSalesNetwork,
  useSalesNetworks,
} from "utils/hooks/useSalesNetworks";
import useTranslation from "utils/hooks/useTranslation";
import PageConnexion from  "../assets/PageConnexion.jpeg"

const ACVNetworkSelect: React.FC = () => {
  const { data } = useSalesNetworks();
  const { network, isLoading } = useSalesNetwork();
  const { open } = usePopover();
  const navigate = useNavigate();

  useEffect(() => {
    if (network && !isLoading && !network.requiredConnexion) {
      navigate(getAppUrl("/", { network: network.code }));
    }
  });

  if (!data || !network) {
    return <></>;
  }

  const options = data
    .filter((network) => network.brands[0].brand === "ACV")
    .map((network) => ({ code: network.code, label: network.name }));

  const onOpen: React.MouseEventHandler = (e) => {
    open({
      element: e.target as any,
      content: (
        <ContextMenuList
          items={options.map((o) => ({
            text: o.label,
            onClick: () => navigate(getAppUrl("/", { network: o.code })),
          }))}
        />
      ),
    });
  };

  return <Button text={network.name} onClick={onOpen} />;
};

export const LoginPage: React.FC = () => {
  const { network } = useSalesNetwork();
  const { language } = useTranslation();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(()=>{
    if (!network?.requiredConnexion) 
    {
      navigate(getAppUrl("/", { network: network?.code }));
    }
    const no_redirect = sessionStorage.getItem("noRedirect");
    if (!no_redirect) {
      const atlantic_sso_user = document.cookie.split('; ').filter(row => row.startsWith('atlantic_sso_user=')).map(c => c.split('=')[1])[0]
      if (atlantic_sso_user) {
        login(false);
      }
    }
    sessionStorage.setItem("noRedirect", "true");
  },[])

  const login = (isInternal: boolean = false) => {
    if (!network || !language) {
      return;
    }

    loginRequest({
      code: network.code,
      language,
      isInternal: isInternal,
    }).then((res) => {
      window.location.href = res.data.redirectUrl;
    });
  };

  return (
    <>
      {network?.brands[0]?.brand === "ACV" && (
        <group data-justify="end">
          <ACVNetworkSelect />
        </group>
      )}
      <view
        data-space="40"
        data-gap="30"
        data-scroll=""
        data-background="highlight"
        data-align="center"
      >
       <picture data-duration=".125" data-position="absolute" data-top="0" data-left="0">
           <img src={PageConnexion} alt="" />
        </picture>
        <group
          data-border=""
          data-radius="15"
          data-contain=""
          data-background="main-background"
          data-shrink="no"
          data-max-length="700"
        >
          <group data-space="40">
            <group data-gap="10">
              <Button
                data-height="60"
                data-radius="special"
                data-space="20"
                data-length="forcefit"
                data-fit="1"
                primary
                text={t("FO_CONNECT")}
                onClick={() => {
                  login();
                }}
              />
              <Button
                data-height="60"
                data-radius="special"
                data-space="20"
                data-length="forcefit"
                data-fit="1"
                primary
                text={t("AZUREAD_CONNEXION_BUTTON")}
                onClick={() => {
                  login(true);
                }}
              />
            </group>
            <space data-height="10"></space>
            <separator data-horizontal=""></separator>
            {network?.registerUrl && (
              <group data-justify="end">
                <a href={network.registerUrl}>
                  <Button text={t("FO_ACCOUNT_CREATION")} />
                </a>
                <space data-height="10"></space>
              </group>
            )}
            <group>
              <text data-wrap="wrap">
                {t("FO_TOOLS_DESCRIPTION_THERMODIM")}
              </text>
            </group>
          </group>
        </group>
      </view>
    </>
  );
};
